import slugify from 'slugify';

export const getUtmValues = (name) => {
  const options = {
    replacement: '_',
    lower: true,
    strict: true,
  };
  const utmCampaign = name ? `&utm_campaign=${slugify(name, options)}` : '';

  return `utm_source=email_signature&utm_medium=email${utmCampaign}`;
};
